import { render, staticRenderFns } from "./MLSList.vue?vue&type=template&id=1b5420d9&scoped=true&"
import script from "./MLSList.vue?vue&type=script&lang=js&"
export * from "./MLSList.vue?vue&type=script&lang=js&"
import style0 from "./MLSList.vue?vue&type=style&index=0&id=1b5420d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5420d9",
  null
  
)

export default component.exports